import store from 'reducers'

export default class {
    constructor(options){
        this.organizationID = Object(store.getState().organization).id
        if(options){
            this.client = options.client
        }
    }
    // mark ***
    create(options){
        options.organizationID = this.organizationID;
        return this.client.post(`/organizations/payments`, options)
    }
}


// WEBPACK FOOTER //
// ./lib/apiClient/payments.js